<div class="page">
  <app-header></app-header>
  <div class="main">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- <app-footer></app-footer> -->
</div>
